import { Camera, Check, Workflow } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";
import { useContent } from "@/context/ContentContext";

export default function About() {
  const c = useContent();
  const about = c.about;
  const S = c.settings;

  return (
    <section id="ueber-mich" data-testid="about-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            {about.photo_url ? (
              <img
                src={about.photo_url}
                alt={`${S.company_name} – bei der Arbeit`}
                loading="lazy"
                decoding="async"
                className="w-full aspect-[4/5] object-cover rounded-2xl border border-[#27272A]"
              />
            ) : (
              <div
                data-testid="about-photo-placeholder"
                className="w-full aspect-[4/5] rounded-2xl border border-dashed border-zinc-700 bg-[#121215] flex flex-col items-center justify-center gap-3 text-zinc-500"
              >
                <Camera className="h-8 w-8" />
                <p className="font-mono text-xs uppercase tracking-wider">Foto folgt</p>
              </div>
            )}
            {about.facts?.length > 0 && (
              <div className="mt-4 flex flex-wrap gap-2">
                {about.facts.map((f) => (
                  <span key={f} className="inline-flex items-center gap-1.5 rounded-full border border-zinc-800 bg-[#121215] px-3.5 py-1.5 text-xs font-semibold text-zinc-300">
                    <Check className="h-3.5 w-3.5 text-blue-400" /> {f}
                  </span>
                ))}
              </div>
            )}
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <SectionHead eyebrow={c.texts.about_eyebrow} title={about.heading || S.company_name} />
          <Reveal delay={0.1}>
            <p className="mt-6 text-base text-zinc-300 leading-relaxed whitespace-pre-line">{about.text}</p>
          </Reveal>
          {about.workflow ? (
            <Reveal delay={0.18}>
              <div className="mt-8 rounded-2xl border border-[#27272A] bg-[#121215] p-6">
                <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-zinc-400 mb-3">
                  <Workflow className="h-4 w-4 text-blue-400" /> Arbeitsweise
                </p>
                <p className="text-sm text-zinc-300 leading-relaxed whitespace-pre-line">{about.workflow}</p>
              </div>
            </Reveal>
          ) : null}
        </div>
      </div>
    </section>
  );
}
